import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import isToday from 'dayjs/plugin/isToday';
import dayOfYear from 'dayjs/plugin/dayOfYear';

dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(dayOfYear);

export const getDayOfYear = () => {
  const date = dayjs();
  const day = date.dayOfYear();
  const year = date.format('YYYY');
  return `${year}${day}`;
};
export const isDateToday = date => dayjs(date).isToday();
export const parse = date => dayjs(date);
export const timeFromNow = date => dayjs(date).fromNow();
export const formatTime = date => dayjs(date).format('MMM D, YYYY, hh:mm A');
export const formatDate = date => dayjs(date).format('MMM D, YYYY');
export const currentYear = dayjs().year();



// WEBPACK FOOTER //
// ./src/utils/dateHelpers.js